<template>
  <main id="payouts-list" class="site-main">
    <div class="grid-container">
      <div class="page-header grid-x grid-padding-x align-top">
        <div class="cell auto">
          <h1 class="page-header__title">Customers</h1>
        </div>

<!--        <div class="cell shrink">-->
<!--          <div class="text-right">-->
<!--            <button @click="addCustomer">Add Customer</button>-->
<!--            <button @click="importcustomers">Import Customers</button>-->
<!--          </div>-->
<!--        </div>-->
      </div>

      <div class="panel no-padding">
        <div :class="['loading-area', loading ? 'loading' : '']">
          <div :class="['loading-area__content', loading ? 'loading' : '']">
            <tableList :header="tableHeader" :data="tableData"
                       :loading="loading"
                       classes="no-hover" @sort="orderBy"
                       @callback="callback"></tableList>
          </div>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div class="overlay" v-if="addingCustomer">
        <div class="overlay__inner">
          <div class="panel">
            <div class="panel__header">
              <h3 class="panel__title">Add Customer</h3>

              <span class="overlay__close" @click="closeAddCustomer">
                <i class="fal fa-times"></i></span>
            </div>

            <div class="panel__content">
              <form>
                <div class="form-field">
                  <label for="first-name">First Name</label>
                  <input id="first-name" name="first-name" type="text">
                </div>

                <div class="form-field">
                  <label for="last-name">Last Name</label>
                  <input id="last-name" name="last-name" type="text">
                </div>

                <div class="form-field">
                  <label for="email">Email</label>
                  <input id="email" name="email" type="email">
                </div>
              </form>

              <div class="text-alert-color text-right"
                   v-if="errorMessage !== null" v-html="errorMessage"></div>
            </div>

            <div class="panel__footer text-right">
              <button @click="saveCustomer">Save</button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div class="overlay" v-if="importingCustomers">
        <div class="overlay__inner">
          <div class="panel">
            <div class="panel__header">
              <h3 class="panel__title">Import Customers</h3>

              <span class="overlay__close" @click="closeImportCustomers">
                <i class="fal fa-times"></i></span>
            </div>

            <div class="panel__content">
              <form>
                <p><i>Format:</i> First Name, Last Name, Email</p>
                <div class="form-field">
                  <label for="customers-file">CSV File</label>
                  <input id="customers-file" type="file">
                </div>
              </form>

              <div class="text-right"
                   v-if="errorMessage !== null" v-html="errorMessage"></div>
            </div>

            <div class="panel__footer text-right">
              <button @click="importCustomers">Upload</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </main>
</template>

<script>
import client from '@/mixins/client'
import paginationUtils from '@/mixins/paginationUtils'

import moment from 'moment'

export default {
  mixins: [client, paginationUtils],
  data: function () {
    return {
      addingCustomer: false,
      importingCustomers: false,
      errorMessage: null,
      action: '/vendors/' + this.$store.state.vendors[this.$store.state.currentVendor].id + '/customers/',
      sort: '-first_name',
      tableHeader: {
        currentSort: '-first_name',
        data: [
          {
            label: 'Name',
            class: 'large'
          },
          {
            label: 'Email',
            class: 'full'
          },
          {
            label: 'Status',
            class: 'medium'
          },
          {
            label: 'Date Created',
            class: 'large'
          }
        ]
      },
      tableData: []
    }
  },
  methods: {
    importcustomers () {
      this.importingCustomers = true
    },
    closeImportCustomers () {
      this.importingCustomers = false
    },
    addCustomer () {
      this.addingCustomer = true
    },
    closeAddCustomer () {
      this.addingCustomer = false
    },
    importCustomers () {
      let csv = document.getElementById('customers-file').files[0]

      let readerObj = new FileReader()
      let vendorId = this.$store.state.vendors[this.$store.state.currentVendor].id
      let requestObject = this.request

      let local = this

      readerObj.onload = function () {
        let rows = readerObj.result.split('\n')
        local.errorMessage = ''
        for (let i = 0; i < rows.length; i++) {
          let fields = rows[i].split(',')

          requestObject('post', '/customers/create/', {
            email: fields[2].replaceAll('"', '').trim(),
            first_name: fields[0].trim(),
            last_name: fields[1].trim(),
            vendor: vendorId
          }).then(response => {
            local.getData()
            if (response.email === null) {
              local.errorMessage += '<p class="text-alert-color">Email already exists. Contact store owner.</p>'
            } else {
              local.errorMessage += '<p class="text-success-color">Customer Imported Successfully.</p>'
            }
          })
        }

        setTimeout(function () {
          local.importingCustomers = false
          local.errorMessage = ''
        }, 3000)
      }
      readerObj.readAsText(csv)
    },
    saveCustomer () {
      let email = document.getElementById('email').value
      let firstName = document.getElementById('first-name').value
      let lastName = document.getElementById('last-name').value

      this.request('post', '/customers/create/', {
        email: email,
        first_name: firstName,
        last_name: lastName,
        vendor: this.$store.state.vendors[this.$store.state.currentVendor].id
      }).then(response => {
        if (response.email === null) {
          this.errorMessage = 'Email already exists. Contact store owner.'
        } else {
          this.getData()
          this.addingCustomer = false
          this.errorMessage = ''
        }
      })
    },
    buildTable () {
      this.tableData = []

      for (let i = 0; i < this.data.length; i++) {
        let name = this.data[i].customer__first_name + ' ' + this.data[i].customer__last_name

        let status = 'success'
        let state = this.data[i].customer__state

        if (this.data[i].customer__state === 'invited') {
          status = 'warning'
        } else if (this.data[i].customer__state === 'disabled') {
          this.data[i].customer__state = 'invited'
          status = 'warning'
        }

        let row = {
          post: this.data[i].id,
          data: [
            {
              value: name,
              class: 'large'
            },
            {
              value: this.data[i].customer__email,
              class: 'full'
            },
            {
              value: state,
              class: 'medium',
              span: 'label ' + status
            },
            {
              value: moment(this.data[i].customer__created_at).format('MMM D, YYYY [at] h:mma'),
              class: 'large'
            }
          ]
        }

        this.tableData.push(row)
      }
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style lang="scss">
@import '../../styles/mixins';
@import '../../styles/variables';
</style>



// WEBPACK FOOTER //
// src/pages/vendorPortal/customers.vue